import Vuex from 'vuex';

const state = {
  show: false,
};

const getters = {
  visible: state => state.show,
};

const actions = {
  show: ({ state, commit }, show) => {
		commit('show', show);
  }
};

const mutations = {
	show: (state, show) => {
		state.show = show;
	},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ../shared/store/modules/share.js